type MessageHandler = (message: unknown) => void;

export class RealtimeClient {
  private socket: WebSocket | null = null;
  private readonly listeners = new Set<MessageHandler>();
  private reconnectTimer: number | null = null;

  constructor(private readonly url: string) {}

  connect(onOpen?: () => void, onClose?: () => void) {
    if (this.socket && this.socket.readyState < 2) {
      return;
    }
    const protocol = window.location.protocol === "https:" ? "wss" : "ws";
    this.socket = new WebSocket(`${protocol}://${window.location.host}${this.url}`);
    this.socket.addEventListener("open", () => onOpen?.());
    this.socket.addEventListener("close", () => {
      onClose?.();
      this.scheduleReconnect(onOpen, onClose);
    });
    this.socket.addEventListener("message", (event) => {
      try {
        const parsed = JSON.parse(event.data);
        this.listeners.forEach((listener) => listener(parsed));
      } catch {
        // ignore malformed payloads
      }
    });
  }

  subscribe(handler: MessageHandler) {
    this.listeners.add(handler);
    return () => this.listeners.delete(handler);
  }

  send(type: string, payload: unknown) {
    if (!this.socket || this.socket.readyState !== WebSocket.OPEN) {
      return;
    }
    this.socket.send(JSON.stringify({ type, payload }));
  }

  private scheduleReconnect(onOpen?: () => void, onClose?: () => void) {
    if (this.reconnectTimer !== null) {
      window.clearTimeout(this.reconnectTimer);
    }
    this.reconnectTimer = window.setTimeout(() => this.connect(onOpen, onClose), 2500);
  }
}
